import React, { FC } from 'react'

import styled from 'styled-components'

import InfoIcon from 'src/Assets/Svg/pages-icons/Info.svg?react'

const StyledSecureIcon = styled(InfoIcon)`
  color: ${({ theme }) => theme.color.darkGrey};
  margin-top: 4px;
`

const AutoRenewalInfoTextContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  background: ${({ theme }) => theme.color.white};
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`

const TextTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

const Text = styled(TextTitle)`
  font-weight: 400;
`
export const AutoRenewalInfoText: FC = () => (
  <AutoRenewalInfoTextContainer>
    <StyledSecureIcon />
    <TextContainer>
      <Text>
        By completing this payment, you authorise SoundCampaign to save your
        payment method for future use. It will be charged automatically if
        Auto-Renewal is enabled. You can manage Auto-Renewal at any time from
        your Campaign Details page.
      </Text>
    </TextContainer>
  </AutoRenewalInfoTextContainer>
)
